module.exports = __webpack_public_path__ + "static/media/wedges-loader.b2e327dc.svg";